import React from 'react';
import './Industries.css';

const Industries = () => {
  const industries = [
    {
      id: 1,
      name: 'Defense & Security',
      icon: '🛡️',
      description: 'Advanced navigation systems for national security and defense applications.',
      applications: ['Surveillance', 'Reconnaissance', 'Border Control', 'Critical Infrastructure Protection']
    },
    {
      id: 2,
      name: 'Agriculture',
      icon: '🌾',
      description: 'Precision farming solutions that analyse and optimise crop yields and resource management.',
      applications: ['Crop Monitoring', 'Automated Harvesting', 'Soil Analysis', 'Pest Control']
    },
    {
      id: 3,
      name: 'Manufacturing',
      icon: '🏭',
      description: 'Intelligent automation for production lines and quality control systems.',
      applications: ['Assembly Lines', 'Quality Control', 'Material Handling', 'Packaging']
    },
    {
      id: 4,
      name: 'Oil & Gas',
      icon: '🛢️',
      description: 'Robust solutions for inspection and predictive maintenance in hazardous or hard to reach locations.',
      applications: ['Pipeline Inspection', 'Facility Monitoring', 'Emergency Response', 'Equipment Maintenance']
    },
    {
      id: 5,
      name: 'Mining',
      icon: '⛏️',
      description: 'Heavy-duty robotic solutions for hazardous mining operations and safety enhancement.',
      applications: ['Mine Mapping', 'Scheduling', 'Safety Monitoring', 'Material Transport']
    },
    {
      id: 6,
      name: 'Construction',
      icon: '🏗️',
      description: 'Automated construction processes and smart building management systems.',
      applications: ['Site Surveying', 'Material Placement', 'Quality Inspection', 'Safety Management']
    }
  ];

  return (
    <section id="industries" className="industries">
      <div className="container">
        <div className="section-title">
          <h2>Industries We Serve</h2>
          <p>
            From defense to agriculture, we deliver cutting-edge automation solutions 
            across diverse industrial sectors worldwide.
          </p>
        </div>

        <div className="industries-grid">
          {industries.map((industry) => (
            <div key={industry.id} className="industry-card">
              <div className="industry-header">
                <div className="industry-icon">
                  <span>{industry.icon}</span>
                </div>
                <h3>{industry.name}</h3>
              </div>
              <p className="industry-description">{industry.description}</p>
              <div className="industry-applications">
                <h4>Key Applications</h4>
                <ul>
                  {industry.applications.map((app, index) => (
                    <li key={index}>{app}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="industries-cta">
          <div className="cta-content">
            <h3>Ready to Transform Your Industry?</h3>
            <p>
              Join leading companies worldwide who trust Idle Robotics for their automation needs. 
              Let's discuss how we can optimize your operations.
            </p>
            <div className="cta-actions">
              <a href="#contact" className="btn btn-primary">
                Schedule Consultation
              </a>
              <a href="#demo" className="btn btn-secondary">
                View Case Studies
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries; 